/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { colors, sizes } from '@smartsheet/lodestar-core';
import { ToolbarRefreshIcon } from '@smartsheet/lodestar-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { fetchWorkflowRun } from '../../../../../../services/ducks/workflowRunDuck/workflowRunDuck';
import { IconButtonNoSpacing } from '../../../../../common/IconButton';
import SuggestRefreshGraphic from '../../../../../icons/SuggestRefreshGraphic';

const containerStyle = css`
  margin-top: ${sizes.large}px;
  text-align: center;
`;

export const StepError = () => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const runRefreshHandler = () => {
    dispatch(fetchWorkflowRun());
  };
  return (
    <div css={containerStyle}>
      <SuggestRefreshGraphic
        height="135px"
        width="100%"
        margin="auto !important"
      />
      <p>
        Run logs aren&apos;t loading right now.
        <br />
        Sorry about the headache! Please try refreshing and,
        <br />
        if that doesn&apos;t work, check your internet connection.
      </p>
      <div>
        <IconButtonNoSpacing
          onClick={runRefreshHandler}
          appearance="borderless"
          color={colors.buttonPrimary}
          aria-label={translate('designer:runLog.refresh')}
        >
          <ToolbarRefreshIcon />
        </IconButtonNoSpacing>
      </div>
    </div>
  );
};
